<template>
    <div class="expanded-request">
                <Platform 
                    :campaign-id = "campaignId" 
                    :request = "data" 
                    @setRequestData="setRequestData"
                />
        <div class="container-fluid">
            <div class="row">
                <div class="col-6">
                    <Conversation :request = "data"/>
                </div>
                <div class="col-6">
                    <FeedBack 
                        :request = "data" 
                        :set-request-data="setRequestData"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Platform from './Platform'
import Conversation from './Conversation'
import FeedBack from './FeedBack'
export default {
    name: 'ExpandedRequest',
    components: {
        Platform,
        Conversation,
        FeedBack
    },
    props: {
        data: Object,
        setRequestData: Function
    },
    computed: {
        campaignId(){
            return this.$route.query.type === 'sent' ? this.data.receiver.campaign : this.data.sender.campaign 
        }
    },
}
</script>

<style scoped>
div.expanded-request {
    height: 182px;
    display: flex;
    padding-top: 24px;
    padding-bottom: 24px;
    padding-right: 32px;
    padding-left: 32px;
    
}
</style>